import { set_storage, get_storage } from "@/utils/util";

export function loggedIn(key) {
    return get_storage(key) === "1";
}

export function setLoggedIn(key) {
    return set_storage(key, "1");
}

export function removeLoggedIn() {
    return localStorage.removeItem(key);
}
